import useGetSavedLists from '../hooks/useGetSavedLists';
import { useTranslation } from 'react-i18next';
import ListSavedCard from '../components/ListSavedCard';
import { useNavigate } from 'react-router-dom';
import { ListPlus } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const ListsShared = () => {
	const { t } = useTranslation();
	const { listsSaved } = useGetSavedLists();
	const navigate = useNavigate();

	return (
		<div className="w-full">
			<div className="flex flex-col">
				<span className="text-2xl font-bold">
					{t('listSaved.title')}
					<span className="inline-flex items-center gap-2 whitespace-nowrap">
						&#xfeff;
						{/* <span className="inline-block">{renderDropdown()}</span> */}
					</span>
				</span>
			</div>
			<div className="mt-4 flex flex-col gap-3 pb-24">
				{listsSaved.map((savedList) => (
					<ListSavedCard
						key={savedList.id}
						savedList={savedList}
						onClick={() =>
							navigate(`/shared/${savedList.public_uid}`)
						}
					/>
				))}
				{listsSaved.length === 0 && (
					<Card className="mx-auto w-full max-w-md sm:mx-0">
						<CardContent className="flex flex-col items-center justify-center space-y-4 p-6 text-center">
							<div className="rounded-full bg-muted p-3">
								<ListPlus className="h-8 w-8 text-muted-foreground" />
							</div>
							<h3 className="text-lg font-semibold">
								{t('listSaved.empty')}
							</h3>
							<p className="text-sm text-muted-foreground">
								{t('listSaved.emptyDescription')}
							</p>
						</CardContent>
					</Card>
				)}
			</div>
		</div>
	);
};

export default ListsShared;
